import Placeholder from 'assets/img/covers/placeholder.jpg';
import ProfilePlaceholder from 'assets/img/profile_placeholder.png';
import PropTypes from 'prop-types';
import React from 'react';
import { FiShoppingBag } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { formatPrice } from 'utils/products';
import * as Ui from './ProductCustomerPreview.styles';

const ProductCustomerPreview = ({
  color,
  currency,
  description,
  media,
  name,
  originImage,
  price,
  size,
}) => {
  const { t } = useTranslation('app');
  const previewName = name?.trim() || t('mediaCrop.productNameFallback');
  const previewDescription = description?.trim() || t('mediaCrop.productDescriptionFallback');
  const previewPrice =
    price !== undefined && price !== null && currency
      ? formatPrice(price, currency)
      : t('mediaCrop.productPriceFallback');
  const previewSize = size?.name || size || t('mediaCrop.productSizeFallback');
  const previewColor = color?.hex_value || 'transparent';

  return (
    <Ui.ProductCard>
      <Ui.ProductMediaFrame>
        <Ui.PreviewImage
          src={media || Placeholder}
          alt={media ? previewName : t('mediaCrop.productPreviewAlt')}
        />
      </Ui.ProductMediaFrame>
      <Ui.ProductCardPanel>
        <Ui.ProductOwnerAvatar src={originImage || ProfilePlaceholder} alt="" aria-hidden="true" />
        <Ui.ProductCardName>{previewName}</Ui.ProductCardName>
        <Ui.ProductCardDescription>{previewDescription}</Ui.ProductCardDescription>
        <Ui.ProductCardVariantControls aria-hidden="true">
          <Ui.ProductCardSize>{previewSize}</Ui.ProductCardSize>
          <Ui.ProductCardColor $color={previewColor} />
        </Ui.ProductCardVariantControls>
        <Ui.ProductCardActions>
          <Ui.ProductCardPrice>{previewPrice}</Ui.ProductCardPrice>
          <Ui.BasketButton type="button" disabled aria-label={t('mediaCrop.basketPreview')}>
            <FiShoppingBag aria-hidden="true" />
          </Ui.BasketButton>
        </Ui.ProductCardActions>
      </Ui.ProductCardPanel>
    </Ui.ProductCard>
  );
};

ProductCustomerPreview.propTypes = {
  color: PropTypes.shape({
    hex_value: PropTypes.string,
    name: PropTypes.string,
  }),
  currency: PropTypes.string,
  description: PropTypes.string,
  media: PropTypes.string,
  name: PropTypes.string,
  originImage: PropTypes.string,
  price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      name: PropTypes.string,
    }),
  ]),
};

export default ProductCustomerPreview;
